import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { VipAdd, VipGrabber } from './VipSidebar';
import { VipEdit } from './admin/VipEdit';
import { VipGuest } from './guest/VipGuest';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const VipConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/VIPCustomComponent.json',
  componentType: 'Vip',
  adminSidebarComponent: {
    addComponentView: VipAdd,
    dragComponentView: VipGrabber,
    editComponentView: VipEdit,
    createComponentView: VipEdit,
  },
  guestSiteComponent: VipGuest,
};
